import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '../assets/images/notclicked.png'
import _imports_1 from '../assets/images/clicked.png'


const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "search-input-group" }
const _hoisted_3 = {
  key: 1,
  class: "operate"
}
const _hoisted_4 = ["onClick"]
const _hoisted_5 = {
  key: 0,
  src: _imports_0,
  alt: ""
}
const _hoisted_6 = {
  key: 1,
  src: _imports_1,
  alt: ""
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_breadcrumb_item = _resolveComponent("a-breadcrumb-item")!
  const _component_a_breadcrumb = _resolveComponent("a-breadcrumb")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_menu_item = _resolveComponent("a-menu-item")!
  const _component_a_menu_divider = _resolveComponent("a-menu-divider")!
  const _component_a_menu = _resolveComponent("a-menu")!
  const _component_a_dropdown = _resolveComponent("a-dropdown")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_pagination = _resolveComponent("a-pagination")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_breadcrumb, { class: "breadcrumb" }, {
      default: _withCtx(() => [
        _createVNode(_component_a_breadcrumb_item, { class: "black" }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.t("set")), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_a_breadcrumb_item, { class: "currentrouter" }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.t("usermanage")), 1)
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_a_input, {
        style: {"width":"15%"},
        value: _ctx.keyWord,
        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.keyWord) = $event)),
        placeholder: _ctx.t('supportusernamesearch')
      }, null, 8, ["value", "placeholder"]),
      _createVNode(_component_a_button, {
        class: "searchBtn",
        onClick: _ctx.search
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.t("search")), 1)
        ]),
        _: 1
      }, 8, ["onClick"]),
      _createVNode(_component_a_button, {
        class: "searchBtn addBtn",
        onClick: _ctx.addUserF
      }, {
        default: _withCtx(() => [
          _createTextVNode("+ " + _toDisplayString(_ctx.t("newusers")), 1)
        ]),
        _: 1
      }, 8, ["onClick"])
    ]),
    _createVNode(_component_a_table, {
      dataSource: _ctx.dataSource,
      columns: _ctx.columns,
      pagination: false,
      scroll: { y: _ctx.maxHeight, x: 1100 }
    }, {
      bodyCell: _withCtx(({ record, column, index }) => [
        (column.title === _ctx.t('serialnumber'))
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createTextVNode(_toDisplayString(index + 1), 1)
            ], 64))
          : (column.dataIndex === 'car_model')
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createVNode(_component_a_dropdown, { trigger: ['click'] }, {
                  overlay: _withCtx(() => [
                    _createVNode(_component_a_menu, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_menu_item, {
                          key: "0",
                          onClick: ($event: any) => (_ctx.userEdit(record.id))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.t("edit")), 1)
                          ]),
                          _: 2
                        }, 1032, ["onClick"]),
                        _createVNode(_component_a_menu_divider),
                        _createVNode(_component_a_menu_item, {
                          key: "1",
                          onClick: ($event: any) => (_ctx.showDialogVisible(record))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.t("delete")), 1)
                          ]),
                          _: 2
                        }, 1032, ["onClick"])
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  default: _withCtx(() => [
                    _createElementVNode("a", {
                      class: "ant-dropdown-link",
                      onClick: ($event: any) => (_ctx.checkItem(record.id))
                    }, [
                      (record.id !== _ctx.checkedId)
                        ? (_openBlock(), _createElementBlock("img", _hoisted_5))
                        : (_openBlock(), _createElementBlock("img", _hoisted_6))
                    ], 8, _hoisted_4)
                  ]),
                  _: 2
                }, 1024)
              ]))
            : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["dataSource", "columns", "scroll"]),
    _createVNode(_component_a_pagination, {
      class: "pagination",
      "show-size-changer": "",
      "show-quick-jumper": "",
      "show-total": (total) => `${_ctx.t('intotal')} ${total}${_ctx.t('article')}`,
      current: _ctx.pagination.page,
      "onUpdate:current": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.pagination.page) = $event)),
      pageSize: _ctx.pagination.size,
      "onUpdate:pageSize": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.pagination.size) = $event)),
      total: _ctx.pagination.total,
      size: "small",
      onChange: _ctx.getListData
    }, null, 8, ["show-total", "current", "pageSize", "total", "onChange"])
  ]))
}